module.exports = __webpack_public_path__ + "static/media/interior5.491bddb3.webp";